import { getEasyClaimAuthorizationHeaders } from '../easyclaim.app.configuration/ciapiAuthorization';
import { getEasyClaimEnv } from '../easyclaim.app.configuration/env';

export class ThumbnailNotReadyError extends Error {
	constructor() {
		super('Thumbnail not ready yet');
		this.name = 'ThumbnailNotReadyError';
	}
}

const DEFAULT_THUMBNAIL_WIDTH = 400;
const DEFAULT_THUMBNAIL_HEIGHT = 300;

export interface FetchThumbnailParams {
	caseId: string;
	imageId: string;
	width?: number;
	height?: number;
	signal?: AbortSignal;
}

export interface FetchThumbnailResult {
	blob: Blob;
	objectUrl: string;
}

export async function fetchThumbnail({
	caseId,
	imageId,
	width = DEFAULT_THUMBNAIL_WIDTH,
	height = DEFAULT_THUMBNAIL_HEIGHT,
	signal,
}: FetchThumbnailParams): Promise<FetchThumbnailResult> {
	const { basePath, apiKey } = getEasyClaimEnv();
	const url = new URL(`${basePath}/api/v1/image/thumbnail`);

	url.searchParams.set('caseId', caseId);
	url.searchParams.set('imageId', imageId);
	url.searchParams.set('width', String(width));
	url.searchParams.set('height', String(height));

	const response = await fetch(url, {
		headers: {
			'x-apikey': apiKey,
			...getEasyClaimAuthorizationHeaders(),
		},
		signal,
	});

	if (response.status === 404) {
		throw new ThumbnailNotReadyError();
	}

	if (!response.ok) {
		throw new Error(`Thumbnail request failed with status ${response.status}`);
	}

	const blob = await response.blob();

	return { blob, objectUrl: URL.createObjectURL(blob) };
}
